import _ from 'underscore'
import Core from '../core'
import $ from 'jquery'
/**
 * Modulo Visibility
 * @module abstracts/visibility
 * @namespace Abstracts/Visibility
 */

/**
 * Classe responsável por gestão de elementos lazyloading
 *
 * @name Visibility
 * @typedef {Object} Visibility
 * @memberof abstracts/visibility
 */
class Visibility {
    async init () {
        this._Views = []

        const checkAll = _.throttle(() => {
            this.checkAll()
        }, 500)

        Core.Tasks.add(Core.Events.PAGE_SCROLL, checkAll)
    }

    addView (view) {
        // this._ViewsCollections.add({ view, $el: view.$el, repeat: view.repeat })
        this._Views.push(view)
    }

    async checkAll () {
        if (this._Views.length === 0) {
            return
        }

        const promises = []
        for (let i = 0; i < this._Views.length; i++) {
            promises.push(new Promise((resolve, reject) => {
                (() => {
                    try {
                        const view = this._Views[i]

                        view.visibility = Math.round(this.calculeVisibility(view.$el))

                        resolve(Math.round(view.visibility))
                    } catch (ex) {
                        console.error(ex)
                    }
                })()
            }))
        }

        const visibles = await Promise.all(promises)

        // Calcula a maior visibilidade
        const max = visibles.reduce((a, b) => {
            return Math.max(a, b)
        })

        let found = false
        for (let i = 0; i < this._Views.length; i++) {
            (() => {
                try {
                    const view = this._Views[i]

                    if (view.visibility === max && found === false) {
                        found = true
                        view.watch()
                    }
                } catch (ex) {
                    console.error(ex)
                }
            })()
        }
    }

    calculeVisibility ($el) {
        const windowHeight = $(window).height()
        const docScroll = $(document).scrollTop() + 60
        const divPosition = $el.offset().top
        const divHeight = $el.height()
        const hiddenBefore = docScroll - divPosition
        const hiddenAfter = (divPosition + divHeight) - (docScroll + windowHeight)

        if ((docScroll > divPosition + divHeight) || (divPosition > docScroll + windowHeight)) {
            return 0
        } else {
            let result = 100

            if (hiddenBefore > 0) {
                result -= (hiddenBefore * 100) / divHeight
            }

            if (hiddenAfter > 0) {
                result -= (hiddenAfter * 100) / divHeight
            }

            return result
        }
    }
}

window.GPAbstractModules = window.GPAbstractModules || {}
window.GPAbstractModules.Visibility = Visibility
